export default __webpack_public_path__ + "static/media/041-ice hockey.01d27e03.svg";